import BannerCard from '../components/BannerCard'
import Container from '../components/ui/container'
import HeroWithBackgroundVideo from '../containers/hero-with-background-video'
import { Page } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'
import { CustomVideo } from './FullWidthDynamicBlock'

export type BlockProps = Extract<Page['hero'][0], { blockType: 'hero-background-video' }>
export type ButtonsType = BlockProps['buttons']

function HeroBackgroundVideo(block: BlockProps): ReactElement {
  const { title, description, buttons, video, options } = block

  const terminal = options?.terminal
  const overlayOpacity = options?.overlayOpacity ?? 100
  return (
    <HeroWithBackgroundVideo
      video={video as CustomVideo['video']}
      padding={false}
      overlayOpacity={overlayOpacity}
    >
      <div className="z-30 relative overflow-hidden">
        <Container className="h-screen flex justify-center items-center">
          <BannerCard
            title={title}
            description={description}
            idx={0}
            buttons={buttons}
            terminal={terminal}
          />
        </Container>
      </div>
    </HeroWithBackgroundVideo>
  )
}

export default HeroBackgroundVideo
